import type { IconSvgProps } from '../Icon.types';

export const StarSimple = ({ width, height }: IconSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    
  >
    <path
      d="M9.98921 9.98921L8.46796 14.173C8.43244 14.2686 8.36849 14.3512 8.2847 14.4095C8.2009 14.4677 8.10128 14.499 7.99921 14.499C7.89714 14.499 7.79752 14.4677 7.71373 14.4095C7.62993 14.3512 7.56598 14.2686 7.53046 14.173L6.01171 9.98921L1.82796 8.46796C1.73227 8.43244 1.64975 8.36849 1.59147 8.2847C1.53319 8.2009 1.50195 8.10128 1.50195 7.99921C1.50195 7.89714 1.53319 7.79752 1.59147 7.71373C1.64975 7.62993 1.73227 7.56598 1.82796 7.53046L6.01171 6.01171L7.53296 1.82796C7.56848 1.73227 7.63243 1.64975 7.71623 1.59147C7.80002 1.53319 7.89964 1.50195 8.00171 1.50195C8.10378 1.50195 8.2034 1.53319 8.2872 1.59147C8.37099 1.64975 8.43494 1.73227 8.47046 1.82796L9.99171 6.01171L14.1755 7.53296C14.2711 7.56848 14.3537 7.63243 14.412 7.71623C14.4702 7.80002 14.5015 7.89964 14.5015 8.00171C14.5015 8.10378 14.4702 8.2034 14.412 8.2872C14.3537 8.37099 14.2711 8.43494 14.1755 8.47046L9.98921 9.98921Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
